import type { FC } from 'react';
import { useFormikContext } from 'formik';

import * as Core from 'components/core';
import { Values } from './types';
import { useTranslation } from 'react-i18next';

interface Props {
  disabled?: boolean;
}

const AddressFields: FC<Props> = (props) => {
  const { disabled = false } = props;
  const { t } = useTranslation();
  const { values, handleChange, handleBlur } = useFormikContext<Values>();

  return (
    <>
      <Core.InputFormGroup
        name="addressName"
        autoComplete="name"
        value={values.addressName}
        label={t('address.name')}
        required
        disabled={disabled}
        testID="address-name-field"
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Core.InputFormGroup
        name="addressCompany"
        autoComplete="organization"
        value={values.addressCompany}
        label={t('address.company')}
        disabled={disabled}
        testID="address-company-field"
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Core.InputFormGroup
        name="addressLine1"
        autoComplete="address-line1"
        value={values.addressLine1}
        label={t('address.line1')}
        required
        disabled={disabled}
        testID="address-line1-field"
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Core.InputFormGroup
        name="addressLine2"
        autoComplete="address-line2"
        value={values.addressLine2}
        label={t('address.line2')}
        disabled={disabled}
        testID="address-line2-field"
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Core.InputFormGroup
        name="addressLocality"
        autoComplete="address-level2"
        value={values.addressLocality}
        label={t('address.locality')}
        required
        disabled={disabled}
        testID="address-locality-field"
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Core.InputFormGroup
        name="addressRegion"
        autoComplete="address-level1"
        value={values.addressRegion}
        label={t('address.region')}
        disabled={disabled}
        testID="address-region-field"
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Core.FormGroup label={t('address.country')} required>
        {({ inputID }) => (
          <Core.CountrySelect
            id={inputID}
            name="addressCountryCode"
            autoComplete="country"
            value={values.addressCountryCode}
            required
            disabled={disabled}
            testID="address-country-select"
            onChange={handleChange}
            onBlur={handleBlur}
          />
        )}
      </Core.FormGroup>

      <Core.InputFormGroup
        name="addressPostalCode"
        autoComplete="postal-code"
        value={values.addressPostalCode}
        label={t('address.postalCode')}
        required
        disabled={disabled}
        testID="address-postal-code-field"
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </>
  );
};

AddressFields.displayName = 'Checkout.AddressFields';

export default AddressFields;
